import { 
    CreateLevelDto, 
    DeleteLevelDto,
    EditLevelDto,
    GetLevelDto, 
    MessageResponseDto, 
    UtilityLevelApiFp,
    UtilLevelControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseLevelModel = UtilLevelControllerGet200Response;
export type GetLevelModel = GetLevelDto;
export type MutateResponseLevelModel = MessageResponseDto;
export type CreateLevelModel = CreateLevelDto;
export type UpdateLevelModel = EditLevelDto;
export type DeleteLevelModel = DeleteLevelDto;

export interface CreateLevelModelExtension {
  level: CreateLevelModel;
  file: File;
}

export interface UpdateLevelModelExtension {
  level: UpdateLevelModel;
  file: File;
}

export const apiLevelFp =  UtilityLevelApiFp(apiConfig);
export const getLevelController = apiLevelFp.utilLevelControllerGet;
export const createLevelController = apiLevelFp.utilLevelControllerCreate;
export const updateLevelController = apiLevelFp.utilLevelControllerEdit;
export const deleteLevelController = apiLevelFp.utilLevelControllerDelete;

export const QueryKeyLevel = QueryKey.Level;